export const textsPt = {
  privacyPolicy: 'Política de privacidade',
  termsOfUse: 'Termos de Uso',
  mainHeader: ` Ferramentas financeiras: Calculadora 12C, empréstimo,
  amortização de financiamento, investimentos, juros compostos`,
};
